import {Fancybox, Carousel, Panzoom} from '@fancyapps/ui';
window.Fancybox = Fancybox;
window.Carousel = Carousel;
window.Panzoom = Panzoom;
